export enum SupportPlanTaskType {
  ANALYSIS = 'ANALYSIS',
  CONSULTATION = 'CONSULTATION',
  LONG_TERM_TASK = 'LONG_TERM_TASK'
}